import { createQueryKeys } from '@lukemorales/query-key-factory';

export const aiBdc = createQueryKeys('ai-bdc', {
	settings: (spId: string) => ({
		queryKey: [spId],
	}),
	macroInformation: (spId: string) => ({
		queryKey: [spId],
	}),
});
